import { extendTheme, theme as base } from "@chakra-ui/react"

const colors = {
  transparent: 'transparent',
  black: '#000000',
  white: '#ffffff',
  grey: {
    500: '#49494999',
    400: '#2c2c2c',
    300: '#8A8F93',
    100: '#E2E2E2'
  },
  primary: {
    500: '#456EFF',
  },
  success: {
    500: '#00BD35',
  },
}

const fonts = {
  PlusJakartaSansExtraBold: `'PlusJakartaSansExtraBold', ${base.fonts?.body}`,
  PlusJakartaBold: `'PlusJakartaSansBold', ${base.fonts?.body}`,
  PlusJakartaSansSemiBold: `'PlusJakartaSansSemiBold', ${base.fonts?.body}`,
  PlusJakartaSansMedium: `'PlusJakartaSansMedium', ${base.fonts?.body}`,
  PlusJakartaSansRegular: `'PlusJakartaSansRegular', ${base.fonts?.body}`,
  PlusJakartaSansLight: `'PlusJakartaSansLight', ${base.fonts?.body}`,
};

const theme = extendTheme({ colors, fonts });
export default theme;